module.exports = __webpack_public_path__ + "static/media/ball_ended_eye_link.4d3bce86.webp";